export var SiteDirection;
(function (SiteDirection) {
    SiteDirection["rightToLeft"] = "right";
    SiteDirection["leftToRight"] = "left";
})(SiteDirection || (SiteDirection = {}));
//# sourceMappingURL=SiteDirection.js.map